import {
  // getChildrenDataTable,
  getChildrenInfo,
  getChildrenForSelect,
  getChildrenByApplication
} from '../../api/api.js';
import Swal from 'sweetalert2';
import {
  REQUEST_CHILDREN_DATA,
  SUCCESS_CHILDREN_DATA,
  GET_ERRORS,
  GET_SELECT_CHILDREN,
  SELECT_CHILDREN,
  SUCCESS_CHILDREN_BY_APP_ID,
  REQUEST_CHILDREN_BY_APP_ID
} from './types';
import axios from 'axios';

const Toast = Swal.mixin({
  toast: true,
  position: 'top-center',
  showConfirmButton: false,
  timer: 10000,
  customClass: {
    title: 'title-class'
  }
});

function requestChildrenTable(data) {
  return {
    type: REQUEST_CHILDREN_DATA
  };
}
export function receiveChildrenTable(data) {
  return {
    type: SUCCESS_CHILDREN_DATA,
    payload: data
  };
}

export function getChildrenData(id) {
  return function(dispatch) {
    const data = {
      applicantid: id
    };
    dispatch(requestChildrenTable());
    //console.log("запрос детей",data)
    axios
      .all([getChildrenInfo(data), getChildrenForSelect(id)])
      .then(
        axios.spread((res, arrChildren) => {
          //console.log("пришел запрос",res.data)
          dispatch(receiveChildrenTable(res.data));
          localStorage.setItem('childrenList', JSON.stringify(res.data));

          dispatch(getChildrenSelectArray(arrChildren.data));
          localStorage.setItem(
            'childrenSelect',
            JSON.stringify(arrChildren.data)
          );
        })
      )
      .catch(err => {
        dispatch({
          type: GET_ERRORS,
          payload: err
        });
        Toast.fire({
          title: 'Помилка сервера.Блок:Завантаження списку дітей',
          type: 'error'
        });
      });
  };
}

export const getChildrenSelectArray = data => {
  return {
    type: GET_SELECT_CHILDREN,
    payload: data
  };
};

export const selectChildren = select => {
  return {
    type: SELECT_CHILDREN,
    payload: select
  };
};

export const childrenByAppIDAction = id => dispatch => {
  dispatch({ type: REQUEST_CHILDREN_BY_APP_ID });
  getChildrenByApplication(id)
    .then(response => {
      dispatch(setChildrenByAppID(response.data));
    })
    .catch(err => {
      Toast.fire({
        title: 'Помилка сервера. Блок: Отримання списку дітей',
        type: 'error'
      });
    });
};

export const setChildrenByAppID = data => {
  return {
    type: SUCCESS_CHILDREN_BY_APP_ID,
    payload: data
  };
};
